export default class AuthService {
  static generateToken() {
    const refreshTokenUrl =
      process.env.VUE_APP_COMMON_API_ROOT + "/userservices/refresh-token";
    const refreshToken = localStorage.getItem("refreshToken");
    this.getDMSTokenClient()
      .post(refreshTokenUrl, {
        refresh_token: refreshToken,
      })
      .then((resp) => {
        const respToken = resp.data.access_token;
        localStorage.setItem("token", respToken);
        localStorage.setItem("refreshToken", resp.data.refresh_token);
      })
      .catch((_error) => {
        if (_error && _error.status === 403) {
          this.doLogout();
          return;
        }
        // this.doLogout();
      });
  }
  static doLogout(doRedirect = true) {
    localStorage.clear();
    localStorage.removeItem("bizUnit");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("token");
    localStorage.removeItem("revisionID");
    if (doRedirect) {
      window.location.href = '';
      return;
    }
  }
}
